import React, { Component } from 'react';
import CollapseCard from '../../components/CollapseCard/CollapseCard.js';
import LinkedCompanies from '../../components/LinkedCompanies/LinkedCompanies.js';
import Links from '../../components/Links/Links.js';
import CreateAdvisor from '../demographics/CreateAdvisor.js';
import ContactFieldsEditor from '../../components/Contacts2/ContactFieldsEditor.js';
import NotesCategoriesEditor from '../../components/Notes/NotesCategoriesEditor.js';
import SystemCompaniesContainer from '../../components/Admin/SystemCompaniesContainer.js';
import SalesOpportunitiesAdminContainer from '../../components/SalesOpportunitiesAdmin/SalesOpportunitiesAdminContainer.js';
import CompanyTypes from '../companies/CompanyTypes.js';
import Custodians from '../companies/Custodians.js';
import WorkflowTypes from '../../components/Marketing2/WorkflowTypes.js';
import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import PermissionWrapper from '../../auth/PermissionWrapper.js';
import {
  Container, Row, Col
} from 'reactstrap';

class SystemConfiguration extends Component {

  render() {
    return (<Container fluid className='p-0'>
      <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
        <Row>
          <Col md={12} className='text-center'>
            <h1>System Configuration</h1>
          </Col>
        </Row>
      </PermissionWrapper>
      {/* <PermissionWrapper {...this.props} allowedPermission="Create Advisor" hidden={true}> */}
        <Container fluid>
          <CollapseCard title="Company Types" open={false} header="h3">
            <CompanyTypes {...this.props} />
          </CollapseCard>
        </Container>
         <PermissionWrapper {...this.props} allowedPermission="Edit Notes Categories" hidden={true}>
        <ContactFieldsEditor {...this.props} />
      </PermissionWrapper>
        <Container fluid>
          <CollapseCard title="Custodians" open={false} header="h3">
            <Custodians {...this.props} />
          </CollapseCard>
        </Container>
      {/* </PermissionWrapper> */}
      <PermissionWrapper {...this.props} allowedPermission="Linked Companies" hidden={true}>
        <LinkedCompanies {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="View Links" hidden={true}>
        <Links {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Edit Notes Categories" hidden={true}>
        <NotesCategoriesEditor {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="" hidden={true}>
        <SalesOpportunitiesAdminContainer showAdmin="true" {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="System Companies" hidden={true}>
        <SystemCompaniesContainer {...this.props} />
      </PermissionWrapper>
      <PermissionWrapper {...this.props} allowedPermission="Create Advisor" hidden={true}>
        <Container fluid>
          <CollapseCard title="User-Created Companies" open={false} header="h3">
            <CreateAdvisor {...this.props} />
          </CollapseCard>
        </Container>
      </PermissionWrapper>
      {/* <PermissionWrapper {...this.props} allowedPermission="Workflow Types" hidden={true}> */}
        <Container fluid>
          <CollapseCard title="Workflow Types" open={false} header="h3">
            <WorkflowTypes {...this.props} />
          </CollapseCard>
        </Container>
      {/* </PermissionWrapper> */}
    </Container>)
  }
}

export default SystemConfiguration;
